import { gql } from "@apollo/client";

const DECLINE_TRAINEESHIP = gql`
  mutation declineTraineeship($traineeshipID: String!, $email: String!, $name: String!, $position: String!, $reason: String!, $institution: Int!, $status: String!) {
    declineTraineeship(traineeshipID: $traineeshipID, email: $email, name: $name, position: $position, reason: $reason, institution: $institution, status: $status) 
  }
`;

export default DECLINE_TRAINEESHIP;